<template>
  <nav class="navbar navbar-inverse navbar-fixed-top">
    <router-link to="/app/home" id="home-button-logo" title="accueil">
      <logo />
    </router-link>
    <div class="welcome">Bienvenue sur votre espace pub commerçant<br/></div>
    <div id="top-right-hand-corner">
      <div id="user-stuff" v-if="connexionStatus">
        <div id="user-identity">
          <span v-if="userName.length && userSex === 2">Mme. {{userName}}</span><span v-if="userName.length && userSex === 1">M. {{userName}}</span><br/><router-link to="/app/home" class="nav-link">Mon espace</router-link>
        </div>
      </div>
      <div id="nav-buttons" v-bind:style="currentBgPosition">
        <div style="width: calc(166px / 2); height: 80px; position: absolute; right: calc(166px / 2);" v-if="connexionStatus" @mouseover="spriteTo(80)" @mouseleave="spriteTo(0)">
          <router-link to="/disconnect" id="log-out-button" class="navbar-svg-buttons" title="déconnexion">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="8850 -939 50 34.656"><path d="M35.268,12.672a8.879,8.879,0,0,0-8.8,8.8,1.333,1.333,0,0,0,2.666,0,6.037,6.037,0,0,1,6.135-6.135H46.2a6.037,6.037,0,0,1,6.135,6.135V38.262a6.264,6.264,0,0,1-6.135,6.4H35.268a6.037,6.037,0,0,1-6.135-6.135,1.333,1.333,0,0,0-2.666,0,8.879,8.879,0,0,0,8.8,8.8H46.2a8.879,8.879,0,0,0,8.8-8.8V21.473a8.879,8.879,0,0,0-8.8-8.8H35.268ZM19,44a1.6,1.6,0,0,0,1.067-.267,1.289,1.289,0,0,0,0-1.867L9.4,31.2H36.867a1.333,1.333,0,0,0,0-2.667H9.4L20.067,17.867A1.32,1.32,0,1,0,18.2,16L5.4,28.8a1.289,1.289,0,0,0,0,1.867l12.8,12.8c.267.533.533.533.8.533Z" transform="translate(8845 -951.672)"/></svg>
          </router-link>
        </div>
        <div style="width: calc(166px / 2); height: 80px; position: absolute; right: 0;" @mouseover="(connexionStatus) ? spriteTo(160) : spriteTo(240)" @mouseleave="(connexionStatus) ? spriteTo(0) : spriteTo(80)">
          <router-link to="/app/home" id="home-button" class="navbar-svg-buttons" title="accueil">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="8752 -946 50 47.275"><g transform="translate(8752 -946)"><path d="M43.5,48.917H28.917V35.375H20.583V48.917H6V27.042a1.042,1.042,0,0,1,2.083,0V46.834H18.5V33.292H31V46.834H41.417V28.083a1.042,1.042,0,1,1,2.083,0Z" transform="translate(0.25 -1.641)"/><path d="M48.959,28.016a1.039,1.039,0,0,1-.72-.289L25,5.5,1.761,27.728A1.042,1.042,0,0,1,.321,26.222L25,2.616,49.679,26.221a1.042,1.042,0,0,1-.72,1.795Z" transform="translate(0 -2.616)"/><path d="M39.333,15.375a1.041,1.041,0,0,1-1.042-1.042V8.083h-6.25a1.042,1.042,0,0,1,0-2.083h8.333v8.333A1.041,1.041,0,0,1,39.333,15.375Z" transform="translate(1.292 -2.475)"/></g></svg>
          </router-link>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <a id="top-anchor" href="#top"></a>
      </div>
      <!--/.nav-collapse -->
    </div>
  </nav>
</template>
<script>
  import IndexDisplay from '@/common/lib/IndexDisplay'
  import Logo from '@/components/Logo'
  const AppModules = require('annonces-app-modules')(process.env.APP_NAME, process.env.NODE_ENV)
  export default {
    components: { Logo },
    data () {
      return {
        user: {},
        userSex: 1,
        userName: '',
        customer: {},
        connexionStatus: false,
        currentBgPosition: {
          backgroundPosition: 'right 240px'
        }
      }
    },
    computed: {
      noHomeButton: function () {
        return IndexDisplay(this.$route.path, process.env.APP_NAME)
      }
    },
    mounted: function () {
      document.querySelector('#top-anchor').click()
      this.user = AppModules.getUser()
      this.user.getProperties((err, userProps) => {
        if (err) {
          console.log(err)
        }
        //
        if (userProps && userProps.customers) {
          this.customer = userProps.customers.find((customer) => {
            return customer.role_client === 'GERAN'
          })
        }
        // self.userSex = self.customer && self.customer.sexe_client
        // self.userSex = (self.customer && self.customer.sexe_client) ? self.customer.sexe_client : false
        console.log('*******************************************************')
        console.log('this.customer', this.customer && this.customer.nom_client)
        console.log('this.customer', !!this.customer && this.customer.nom_client)
        console.log('this.customer', this.customer && this.customer.nom_client && this.customer.nom_client.length)
        console.log('this.customer', !!this.customer && !!this.customer.nom_client && !!this.customer.nom_client.length)
        console.log('this.customer', typeof this.customer)
        console.log('*******************************************************')
        this.userSex = !!this.customer && this.customer.sexe_client
        this.userName = !!this.customer && this.customer.nom_client
      })
      //
      return this.user.getConnectionStatus((err, status) => {
        if (err) {
          this.connexionStatus = false
        }
        this.connexionStatus = status
        if (status === true) {
          this.spriteTo(0)
        } else {
          this.spriteTo(80)
        }
      })
    },
    methods: {
      spriteTo: function (spriteHeight) {
        this.currentBgPosition = {
          backgroundPosition: 'right ' + (spriteHeight * -1) + 'px'
        }
      }
    }
  }
</script>



<style>

  .navbar-inverse {
    background-color: var(--primary-color);
    border: none;
    color: var(--secondary-color);
    /* border-bottom: 5px solid var(--secondary-color); */
    -webkit-box-shadow: 3px 3px 0px 2px var(--secondary-color);
    -moz-box-shadow: 3px 3px 0px 2px var(--secondary-color);
    -ms-box-shadow: 3px 3px 0px 2px var(--secondary-color);
    box-shadow: 3px 3px 0px 2px var(--secondary-color);
    box-sizing: content-box;
  }

  .navbar-inverse .navbar-brand {
    border-right: 1px solid var(--primary-color);
  }

  .navbar-inverse .navbar-brand, .navbar-inverse .navbar-nav > li > a, .navbar-inverse .navbar-nav > .active > a, .navbar-inverse .navbar-nav > .active > a:hover {
    color: var(--secondary-color);
    background: none;
  }

  .navbar-inverse .navbar-nav > li > a:focus, .navbar-inverse .navbar-nav > li > a:hover {
    text-decoration: underline;
  }

  nav {
    background-size: cover;
    background-position: center bottom;
  }

</style>



// WEBPACK FOOTER //
// Header.vue?251bb32b